module.exports = __webpack_public_path__ + "static/media/smoke.1713a0cd.png";